import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=56de78d0&scoped=true&lang=pug"
import script from "./ConfirmEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmEmail.vue?vue&type=script&lang=js"
import style0 from "./ConfirmEmail.vue?vue&type=style&index=0&id=56de78d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56de78d0",
  null
  
)

export default component.exports